import { useMemo } from 'react';
import { useGetCategoriesQuery } from '../api';

export function useSubcategoryMap() {
  const { data: categoriesData } = useGetCategoriesQuery({});
  
  const map = useMemo(() => {
    const map = new Map();
    if (!categoriesData?.data) return map;
    
    categoriesData.data.forEach(category => {
      if (category.subcategories) {
        category.subcategories.forEach(subcategory => {
          map.set(String(subcategory.id), {
            subcategory,
            category
          });
        });
      }
    });
    
    return map;
  }, [categoriesData]);

  return { map, categories: categoriesData?.data || [] };
}

